import { useLang } from "../i18n";

export const Marquee = () => {
  const { t } = useLang();
  const ITEMS = t("marquee");
  const row = (
    <>
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center shrink-0">
          <span className="font-heading font-bold uppercase text-2xl sm:text-3xl tracking-wide text-outline-orange px-6">
            {item}
          </span>
          <span className="w-2 h-2 bg-safety rotate-45 shrink-0" />
        </span>
      ))}
    </>
  );

  return (
    <div data-testid="marquee" className="relative border-y border-steelborder bg-gunmetal py-5 overflow-hidden">
      <div className="flex w-max animate-marquee">
        <div className="flex shrink-0">{row}</div>
        <div className="flex shrink-0" aria-hidden="true">{row}</div>
      </div>
    </div>
  );
};
